import React from 'react';
import { getDocumentDisplayName } from '../../helpers/dashboard.helper';

const DocumentToAccept = ({ pendingChangeRequest }) => {
  return (
    <div className="center">
      The{' '}
      <a href={pendingChangeRequest.documentUrl} target="_blank" rel="noopener noreferrer" className="underline">
        {getDocumentDisplayName(pendingChangeRequest.documentType)}
      </a>{' '}
      have been updated!
    </div>
  );
};

export default DocumentToAccept;
